import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoadingSpinner from 'components/loading_spinner';
import EmptyState from 'shared/empty_state';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';
import SvnHowToLink from '../svn_how_to_link';

import { getDuplicatePeopleCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/contact/index/people/duplicates/duplicates_pagination';

export class DuplicateContactsView extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    totalCount: PropTypes.number.isRequired
  };

  render() {
    return (
      <>
        <DuplicatesPageHeader />
        <DuplicatesPageTopbar />
        {this.renderResults()}
      </>
    );
  }

  renderResults() {
    const { isLoading, totalCount } = this.props;

    if (isLoading) return <LoadingSpinner />;
    if (totalCount > 0) return this.renderTable();
    return this.renderEmptyState();
  }

  renderEmptyState() {
    return (
      <div className="p-4" name="no-results-card">
        <EmptyState title="No Duplicate Contacts Found" />
        <SvnHowToLink className="mt-4" />
      </div>
    );
  }

  renderTable() {
    return (
      <>
        <DuplicatesTable />
        <DuplicatesPagination />
      </>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicatePeopleCount(state)
});

export default connect(mapStateToProps)(DuplicateContactsView);
